/**
 *
 * AdministratorBCView
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as actions from './actions';
import TenantView from "./TenantView";

class TenantViewContainer extends React.PureComponent {

    componentWillMount() {
        const {params: {ruleId}, handleParams} = this.props;
        if (ruleId) {
            handleParams(ruleId);
        }
    }

    render() {
        return (
            <TenantView {...this.props} />
        );
    }
}

TenantViewContainer.propTypes = {
    params: PropTypes.object,
    handleParams: PropTypes.func,
};

function mapDispatchToProps(dispatch) {
    return {
        handleParams: (ruleId) => dispatch(actions.handleParams(ruleId)),
    };
}

export default connect(null, mapDispatchToProps)(TenantViewContainer);
